module.exports = __webpack_public_path__ + "img/borders5.067b26f8.png";